import type { RouteMonitoring } from '@/pages/Business/pages/Monitoring/models';
import type { ShippingForRouting } from '@/pages/Business/pages/Shippings/models';
import { buildShippingForRoutingFromMonitoringVisit } from './build-shipping-for-routing-from-monitoring-visit';

export function buildShippingsFromRouteMonitoring(
  routeDetail: RouteMonitoring
): ShippingForRouting[] {
  const logisticOperatorId = routeDetail.route.logisticOperatorId?.trim() ?? '';
  const scheduled = routeDetail.route.scheduled ?? '';
  const sorted = [...routeDetail.visits].sort((a, b) => a.order - b.order);
  const list: ShippingForRouting[] = [];
  const ctx = { logisticOperatorId, scheduled };

  for (const visit of sorted) {
    list.push(buildShippingForRoutingFromMonitoringVisit(visit, ctx));
  }

  return list;
}
